
import { defineComponent, onUnmounted, ref, watch } from 'vue';
import { useAccountStore } from '@/store/useAccount';
import { useScannerCouponStore } from '@/store/useScannerCoupon';
import { useUserStore } from '@/store/useUser';
import { storeToRefs } from 'pinia';

export default defineComponent({
  setup() {
    const account = useAccountStore();
    const scannerCoupon = useScannerCouponStore();
    const user = useUserStore();

    const { refreshTime } = storeToRefs(account);
    const { isLoggedIn } = storeToRefs(user);

    const intervalId = ref(null);

    watch(isLoggedIn, async (loggedIn) => {
      if (loggedIn) {
        await initAuthenticatedData();
      } else {
        clearInterval(intervalId.value);
      }
    }, { immediate: true });

    onUnmounted(() => {
      clearInterval(intervalId.value);
    });

    async function initAuthenticatedData(): Promise<void> {
      await Promise.all([
        refreshOdooListAccounts(),
        scannerCoupon.searchErroredCoupons(),
        scannerCoupon.searchNewCoupons(),
      ]);
    }

    async function checkAndRefreshAccounts(): Promise<void> {
      if (refreshTime.value >= new Date().getTime()) {
        return;
      }

      await account.fetchAccounts();
    }

    async function refreshOdooListAccounts(): Promise<void> {
      clearInterval(intervalId.value);
      intervalId.value = setInterval(checkAndRefreshAccounts, 10 * 60 * 1000);
      await checkAndRefreshAccounts();
    }
  },
});
